import { LinkNode } from '@lexical/link';
import { LexicalComposer } from '@lexical/react/LexicalComposer';
import { LexicalErrorBoundary } from '@lexical/react/LexicalErrorBoundary';
import { HistoryPlugin } from '@lexical/react/LexicalHistoryPlugin';
import { LinkPlugin } from '@lexical/react/LexicalLinkPlugin';
import { RichTextPlugin } from '@lexical/react/LexicalRichTextPlugin';
import ContentEditable from '../Templates/Editor/ContentEditable';
import LoadContentPlugin from '../Templates/Editor/Plugin/LoadContentPlugin';
import ReadOnlyPlugin from '../Templates/Editor/ReadOnlyPlugin';
import "./styles.css";

function onError(error: Error): void {
    console.error('Lexical error:', error);
    throw error;
}

const initialConfig = {
    namespace: 'PreviewEditor',
    theme: {},
    nodes: [LinkNode],
    onError,
}


const HTMLPreview = () => {

    return (
        <LexicalComposer initialConfig={initialConfig}>
            <RichTextPlugin
                contentEditable={
                    <div className="editor-scroller">
                        <div className="editor" >
                            <ContentEditable placeholder="" />
                        </div>
                    </div>
                }
                placeholder={null}
                ErrorBoundary={LexicalErrorBoundary}
            />
            <LoadContentPlugin />
            <ReadOnlyPlugin />
        </LexicalComposer>
    );
};

export default HTMLPreview;